export function invariant(
	condition: boolean,
	message: string = "Invariant violation",
): asserts condition {
	if (!condition) {
		throw new Error(message);
	}
}
